/**
 * Institutions Service
 *
 * A comprehensive service for managing financial institutions and organizations.
 *
 * Features:
 * - Full CRUD operations for institutions (read-only currently)
 * - Institution type management
 * - Matter-institution relationships
 * - Search and filtering capabilities
 * - Mock data support for development
 * - React Query hooks for state management
 * - TypeScript support with full type safety
 */

// Types
export * from './types';

// Server actions
export {
  getInstitutionsAction,
  getMatterInstitutionsAction,
  batchAddMatterInstitutionsAction,
  updateInstitutionAction,
  setInstitutionFirmContactAction
} from './actions';

// Client helpers (directApiClient-backed, usable outside hooks)
export { getMatterInstitutions } from './client';

// React hooks
export {
  useInstitutionSearch,
  useInstitution,
  useInstitutionTypes,
  useMatterInstitutions,
  useGroupedInstitutions,
  useUpdateInstitution,
  useSetInstitutionFirmContact,
  useBatchAddInstitutions,
  useLetterTypes,
  useCreateMatterParty,
  useCreateMatterContactRecipient,
  useAttachMatterContactRecipient
} from './hooks';

// The shared institution-search primitive (VALE-1465) — every picker driven
// by typed input consumes this rather than rolling its own fetch.
export {
  useInstitutionPickerSearch,
  useInstitutionSearchField
} from './use-institution-search';
export type {
  InstitutionSearchScope,
  UseInstitutionPickerSearchResult,
  UseInstitutionSearchFieldResult
} from './use-institution-search';

// Utilities
export {
  // Formatting
  formatInstitutionName,
  getInstitutionTypeLabel,

  // Cache keys
  getInstitutionsCacheKey,
  getInstitutionCacheKey,
  getInstitutionTypesCacheKey,
  getInstitutionTypeCacheKey,
  getMatterInstitutionsCacheKey,
  getGroupedInstitutionsCacheKey,
  getLetterTypesCacheKey
} from './utils';
